module.exports = __webpack_public_path__ + "img/lv10.74a25fc6.png";